import { gql } from 'apollo-angular';
import {
  SelfDisclosureQuestion,
  SelfDisclosureRequestResponseData
} from '@ui/shared/model';

export interface SelfDisclosureQueryResponse {
  selfDisclosureModel: {
    id: string;
    confirmations?: string[];
    feedbackEmail?: string;
    description?: string;
    emailMustBeUnique?: boolean;
    phoneMustBeUnique?: boolean;
    documents?: string[];
    questions?: SelfDisclosureQuestion[];
  };
}

export interface SelfDisclosureAnswerResponse {
  getSelfDisclosureResponses: SelfDisclosureRequestResponseData;
}

export interface SelfDisclosureSaveResponse {
  saveSelfDisclosureResponses: {
    status: number;
    statusText: string;
  };
}

export const selfDisclosureQuery = gql`
  query selfDisclosureModel($id: ID!) {
    selfDisclosureModel(id: $id) {
      id
      feedbackEmail
      questions {
        id
        title
        mandatory
        showSelfDisclosureQuestions
        type
        commentAllowed
        commentHint
        uploadAllowed
        uploadHint
        subQuestions {
          id
          constantName
          title
          type
          showSelfDisclosureQuestions
          mandatory
          commentAllowed
          commentHint
        }
      }
      documents
      confirmations
      description
      emailMustBeUnique
      phoneMustBeUnique
    }
  }
`;

export const selfDisclosureResponses = gql`
  query getSelfDisclosureResponses($id: ID!) {
    getSelfDisclosureResponses(id: $id)
  }
`;

export const saveSelfDisclosureResponsesMutation = gql`
  mutation saveSelfDisclosureResponses($id: ID, $input: JSON) {
    saveSelfDisclosureResponses(id: $id, input: $input) {
      status
      statusText
    }
  }
`;
